(()=>{const root=window.document.getElementById('stikkma-hats-v1');if(!root)return;
const resolve=window.StikkmaHatAssets.resolve,Image=window.StikkmaHatAssets.Image,fetch=window.StikkmaHatAssets.fetch;
const document=new Proxy(window.document,{get(t,p){if(p==='querySelector')return s=>root.querySelector(s);if(p==='querySelectorAll')return s=>root.querySelectorAll(s);if(p==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));const v=Reflect.get(t,p,t);return typeof v==='function'?v.bind(t):v;}});
/* One validated motif identity for rendering, saved designs, prices and the basket. */
window.StikkmaHatMotifs=(()=>{
  const library=window.StikkmaMotifs,tools=window.StikkmaMotifTools;
  const adapter=library?.loaded?window.CuscoMotifAdapter.create({library,legacyAliases:{}}):null;
  const legacyNames={heart:'Herz',mountain:'Berglinie',paw:'Pfote'};
  function identity(config={}){
    if(library?.loaded)return tools.migrateSelection(config,library,{});
    const id=config.motifId||config.motif||'none',kind=String(id).replace(/^legacy:/,'');
    return legacyNames[kind]?{motifId:'legacy:'+kind,motifStyle:'line',legacyKind:kind,motifLabel:legacyNames[kind]}:{motifId:'none',motifStyle:'nordic'};
  }
  const has=config=>identity(config).motifId!=='none';
  function normalize(config={}){
    const s=identity(config),legacy=s.legacyKind;
    return {motif:s.motifId==='none'?'none':legacy||s.motifId,motifId:s.motifId,motifStyle:s.motifStyle,
      motifLabel:s.motifLabel||'',libraryVersion:legacy?'legacy-v1':s.libraryVersion||'',sourceReference:legacy||s.sourceReference||'',
      ...(s.invalidOriginalId?{invalidMotifId:s.invalidOriginalId}:{})};
  }
  function enrich(config){
    const clean={...config,...normalize(config)};
    clean.motifProperties=has(clean)&&adapter?adapter.cartProperties(clean):{};
    return clean;
  }
  const label=config=>{const s=identity(config);return s.motifLabel||'Ohne Motiv';};
  const styleLabel=config=>tools?.styles[identity(config).motifStyle]||'Als Kontur';
  const prepare=config=>adapter?.prepare(config)||Promise.resolve(null);
  return {adapter,identity,normalize,enrich,has,label,styleLabel,prepare};
})();

})();
